import React from 'react';

import { Content } from './Content.js';

export default class PeopleListNav extends React.Component {

  handleTabChange(tabSlug, event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.changeTab(Content.people[tabSlug].list, tabSlug)
  }

  getSectionSelectedClass(tabSlug) {
    return (this.props.selected === tabSlug) ? 'selected' : '';
  }

  render() {
    return (
      <div className="PeopleListNav">
        <ul>
          {
            Content.people.sections.map((section, index) => (
              <li key={index}>
                <a
                  href=""
                  className={`${this.getSectionSelectedClass(section.slug)}`}
                  onClick={(event) => this.handleTabChange(section.slug, event)}
                >
                  {section.name}
                </a>
              </li>
            ))
          }
        </ul>
        <div className="mask left hidden-sm-down"></div>
        <div className="mask right hidden-sm-down"></div>
      </div>
    );
  }

};
